

import { useState, useEffect } from "react"
import { Button } from "antd"
import { CloseOutlined } from "@ant-design/icons"

export default function WarningDisplay({ warnings = [],setWarnings}) {
  const [isVisible, setIsVisible] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)

  
  useEffect(() => {
    if (warnings.length > 0 && !isDismissed) {
      setIsVisible(true)
    }
  }, [warnings, isDismissed])

  const handleDismissAll = () => {
    setIsVisible(false)
    setTimeout(() => {
      setIsDismissed(true)
    }, 300)
  }

 

  // Don't render if no warnings or dismissed
  if (warnings.length === 0 || isDismissed) {
    return null
  }
  const removeWarning = (name) => {
    setWarnings(prev => prev.filter(w => w.name !== name));
  };

  return (
    <div
      className={`transform transition-all duration-300 ease-in-out bg-yellow-100 bg-opacity-70 ${
        isVisible ? "translate-y-0 opacity-100 scale-100" : "-translate-y-4 opacity-0 scale-95"
      }`}
    >
      <div className="relative  rounded-lg shadow-lg overflow-hidden">
       
        <div className="absolute top-0 left-0 right-0 h-1 "></div>

        <div className="flex items-center justify-between p-2 border-b ">
          <div className="flex items-center space-x-2">
            {/* <AlertTriangle className="h-5 w-5 text-yellow-600" /> */}
            <h3 className="text-sm font-semibold text-yellow-800">Warnings ({warnings.length})</h3>
          </div>
          <button
            onClick={handleDismissAll}
            aria-label="Dismiss all warnings"
          >
            <Button icon={<CloseOutlined />}  />
          </button>
        </div>

        <div className="p-4 space-y-3 max-h-48 overflow-y-auto">
          {warnings.map((warning, index) => {
            const warningId = warning.id || warning.code || `warning-${index}`

            return (
                <div
                key={warningId}
                className="relative flex items-start space-x-3 p-3 bg-white/60 rounded-md border border-yellow-100 hover:bg-white/80 transition-colors"
              >
            
                <Button
                  type="text"
                  size="small"
                  icon={<CloseOutlined />}
                  onClick={() => removeWarning(warning.name)}
                  className="absolute top-1 right-1 text-gray-500 hover:text-red-600"
                />
              
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    {warning.flag && <span className="mb-2">{warning.flag}</span>}
                    {warning.name && (
                      <h4 className="text-sm font-medium text-yellow-900">{warning.name}</h4>
                    )}
                  </div>
              
                  <div className="text-black flex items-center justify-between text-xs">
                    <div>
                      {warning.message && (
                        <pre
                          className={`mt-1 text-xs ${
                            warning.flag === '❌'
                              ? 'bg-red-400 bg-opacity-50'
                              : warning.flag === '⚠️'
                              ? 'bg-yellow-400 bg-opacity-50'
                              : 'bg-green-400 bg-opacity-50'
                          } p-2 rounded`}
                        >
                          {typeof warning.message === 'string'
                            ? warning.message
                            : JSON.stringify(warning.details, null, 2)}
                        </pre>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
            )
          })}
        </div>
        <div className="px-4 py-3  border-t ">
          <div className="flex items-center justify-between text-xs text-yellow-700">
            <span>Dismiss to hide all warnings</span>
            <button onClick={handleDismissAll} className="text-yellow-600 hover:text-yellow-800 font-medium">
              Dismiss All
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
